import { AdTeamId } from '@app/icare/entities/adTeam/schema/ADTeam'
import { entityId } from '@pkg/db/schema'
import type { z } from 'zod'

import { PatientRelation } from './PatientRelation'

export const PatientAdTeamId = entityId('patientAdTeam')

export type PatientAdTeamIdType = typeof PatientAdTeamId.Type

export const PatientADTeamRelationSchema = PatientRelation.extend({
  id: PatientAdTeamId.schema,
  toId: AdTeamId.ref,
})

export type PatientADTeamRelation = z.infer<typeof PatientADTeamRelationSchema>
